import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60b9ffb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-actions" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'EditActions',
  props: {
    editMode: {},
    editText: {}
  },
  emits: [
  'edit',
  'save',
  'cancel',
],
  setup(__props: any, { emit }) {

const props = __props;






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.editMode.canEdit)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn btn-primary btn-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('edit')))
        }, _toDisplayString(props.editText ?? 'Edit'), 1))
      : _createCommentVNode("", true),
    (props.editMode.isEditing)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "submit",
          class: "btn btn-primary btn-sm",
          disabled: !props.editMode.canSave,
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('save')), ["prevent"]))
        }, _toDisplayString(props.editMode.saveText), 9, _hoisted_2))
      : _createCommentVNode("", true),
    (props.editMode.isEditing)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "btn btn-outline-primary btn-sm",
          disabled: !props.editMode.canCancel,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('cancel')))
        }, " Cancel ", 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})